import * as React from 'react';

interface Props {
    height: number;
    color?: string;
}

class SegmentalMan extends React.Component<Props, {}> {

    private width: number = this.props.height / 2.41;

    public render(): JSX.Element {
        return (
            <svg 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="-4821.647 4280.577 57.187 138.119" 
                height={this.props.height} 
                width={this.width}
            >
                <g id="standing-up-man" opacity="0.26" transform="translate(-4821.647 4280.577)">
                    <g id="Group_27" data-name="Group 27" transform="translate(0 0)">
                        <ellipse 
                            id="Ellipse_95" 
                            data-name="Ellipse 95" 
                            fill={this.props.color} 
                            cx="11.391" 
                            cy="11.626" 
                            rx="11.391" 
                            ry="11.626" 
                            transform="translate(16.984)"
                        />
                        <path 
                            id="Path_33" 
                            data-name="Path 33" 
                            fill={this.props.color} 
                            d="M47.8,11.42a20.327,20.327,0,0,0-8.712.108C20.152,13.793,14,36.165,15.74,53.223c.753,7.375,12.144,7.452,11.383,0-.632-6.217-.361-15.6,2.876-22.266V55.269c0,.286.028.555.04.831-.008.132-.038.242-.038.377,0,19.292-.033,38.576-.814,57.853-.346,8.569,12.672,8.536,13.016,0,.612-15.108.766-30.224.8-45.342a14.76,14.76,0,0,0,1.85.005c.038,15.118.187,30.234.794,45.337.346,8.536,13.364,8.569,13.016,0-.781-19.277-.809-38.561-.809-57.853a7.423,7.423,0,0,0-.2-1.666c-.018-8.376-.331-16.759-.235-25.129,3.877,6.7,4.231,16.916,3.558,23.538-.763,7.447,10.63,7.372,11.383,0C74.141,35.806,67.7,12.854,47.8,11.42Z" 
                            transform="translate(-15.459 17.375)"
                        />
                    </g>
                </g>
            </svg>
        );
    }
}

export default SegmentalMan;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/svgs/SegmentalMan.tsx